module.exports = __webpack_public_path__ + "media/images/icons/expand-down-446f8e3880f1cd2c48cf7857ed064a0d.svg";